import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React, { useEffect, useRef } from 'react';
import { View } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue } from 'react-native-reanimated';
import { useFocusEffect, CommonActions } from '@react-navigation/core';

import { authTokenSelector, useStore } from '@store/index';
import { useMyProfile } from '@services/useMyProfile';
import { RootStackNavigator } from 'app/navigation/types';

import { styles } from './styles.web';

type ChatPageProps = NativeStackScreenProps<RootStackNavigator, 'Chat'>;

const ChatPage = ({ navigation }: ChatPageProps) => {
  const mainViewRef = useRef<HTMLIFrameElement | null>(null);

  const authToken = useStore(authTokenSelector);
  const { data: profileData } = useMyProfile();

  const headerAnimation = useSharedValue(100);
  const headerOpacityStyle = useAnimatedStyle(() => ({ opacity: headerAnimation.value }));

  const headerBackground = () => <Animated.View style={[headerOpacityStyle, styles.navbarBackground]} />;

  const sendUserAuthStatus = () => {
    if (!authToken || !profileData) return;

    const payload = JSON.stringify({ type: 'user-login', token: authToken, id: profileData.id });
    mainViewRef.current?.contentWindow?.postMessage(payload, 'https://messages.gato.us');
  };

  useEffect(() => {
    if (!authToken) {
      navigation.navigate('Login');
      return;
    }

    if (mainViewRef.current) sendUserAuthStatus();
  }, [authToken, profileData]);

  useFocusEffect(() => {
    navigation.setOptions({
      // headerTransparent: false,
      // headerBackground,
      title: `GATO | Messages`,
    });
  });

  // render
  window.addEventListener('message', (e) => {
    const { action, data } = e.data;

    if (action === 'navigate-profile') {
      const navigateAction = CommonActions.navigate({
        name: 'UserProfile',
        params: {
          userName: data.id,
        },
        key: `UserProfile-${data.id}`,
      });

      return navigation.dispatch(navigateAction);
    }

    return false;
  });

  const url = 'https://messages.gato.us/index.html';

  return (
    <View style={[styles.container]}>
      <iframe
        ref={mainViewRef}
        title="gato-messages"
        src={url}
        onLoad={sendUserAuthStatus}
        allow="clipboard-read; clipboard-write; allow-forms; allow-popups"
        style={{ width: '100%', height: '100%', border: 0 }}
        sandbox="allow-same-origin   allow-scripts allow-forms allow-popups"
      />
    </View>
  );
};

export default ChatPage;
